module.exports = __webpack_public_path__ + "static/media/VOLTAGE_GAP.3a285541.png";